import { useMutation } from '@tanstack/react-query'
import { resendSignUpCode } from 'aws-amplify/auth'

import { postRequest } from 'src/lib/api-client'
import { logger } from 'src/lib/logger'
import { sendEvent } from 'src/shared/api/events/send-event'

interface ConsumerPhoneResendCodeResponse {
  consumerExists: boolean
  expiresInSeconds: number
  message: string
  phoneHint: string
  success: boolean
}

export const consumerPhoneResendCode = async (
  phoneNumber: string,
): Promise<ConsumerPhoneResendCodeResponse | undefined> => {
  const result = await postRequest<ConsumerPhoneResendCodeResponse>('/auth/consumer/phone/resend', { phoneNumber })
  return result
}

export const useConsumerPhoneResendCode = () => {
  return useMutation({
    mutationFn: async (phoneNumber: string) => {
      const result = await consumerPhoneResendCode(phoneNumber)

      if (!result || result.success === false) {
        throw new Error('Consumer Phone Resend Code: No response or success is false.')
      }

      sendEvent({
        eventType: 'auth_consumer_phone_resend_code',
        info: { phoneNumber },
      })

      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      logger.error('Resend code error:', errorName, errorMessage)

      sendEvent({
        eventType: 'auth_consumer_phone_resend_code_error',
        info: { error: errorName, message: errorMessage },
      })
    },
  })
}

// DEPRECATED - use useConsumerSignInStart instead
export const useConsumerResendCode = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      // Using email as username for consumer accounts
      const result = await resendSignUpCode({ username: email })

      sendEvent({
        eventType: 'auth_consumer_resend_code',
        info: { email },
      })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      console.error('Resend code error:', errorName, errorMessage)

      sendEvent({
        eventType: 'auth_consumer_resend_code_error',
        info: { error: errorName, message: errorMessage },
      })
    },
  })
}
